import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-page-not-found',
  imports: [RouterLink, MatIcon],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.css',
  standalone: true,
})
export class PageNotFoundComponent {
  constructor(private location: Location) {}

  goBack(): void {
    this.location.back();
  }
}
